import request from '@/plugins/axios'
export function queryPage(userId, params) {
  return request({
    url: `/clubUsers/byUser/${userId}`,
    method: 'get',
    params
  })
}
